
























































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { ServicioProxy } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { Mensaje } from '@/pantallas/CopilotoVirtual/Mensaje/mensaje';
import { fetchMantenedorTramos } from './fetchMantenedorTramos';
import TextField from '@/reusable/Form/TextField.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
  },
})
export default class VerCrearModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) Tramo_Seleccionada: any;
  @Prop({ default: false }) isEdit: boolean;
  mensajes: Mensaje[] = [];
  dictionaryFormErrors: any = {};
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  tramoslist: any[] = [];
  cod_ubicacion: any;
  respuesta: any;

  readonly funcionalidad: Funcionalidades = Funcionalidades.MantenedorTramos;

  async crear() {
    let self = this;
    this.loadingService.showLoading();
    if (!this.isEdit) {
      return fetchMantenedorTramos(
        {
          usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,

          nombre_tramo: this.formFields.nombre_tramo.value,
          tipo_tramo: this.formFields.tipo_tramo.value,
          estado: this.formFields.activo.value
            ? this.formFields.estado.value
            : 'true',
        },
        'conecta_mantenedor_tramos/crear_tramo'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
            this.handleCerrar();
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    } else {
      return fetchMantenedorTramos(
        {
          usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
          nombre_tramo: this.formFields.nombre_tramo.value,
          tipo_tramo: this.formFields.tipo_tramo.value,
          estado: this.formFields.activo.value
            ? this.formFields.activo.value
            : 'true',
          id: this.Tramo_Seleccionada,
        },
        'conecta_mantenedor_tramos/editar_tramo'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
            this.handleCerrar();
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    }
  }

  formFields: FormFieldDefMap = {
    id: {
      label: 'Id',
      id: '',
      value: 'Por asignar',
    },
    nombre_tramo: {
      label: 'Nombre Tramo',
      id: '',
      value: '',
    },
    tipo_tramo: {
      label: 'Tipo de Tramo',
      id: '',
      value: '',
    },
    activo: {
      label: 'Estado',
      id: '',
      value: '',
      items: [{ id: 't', label: 'Activo' }, { id: 'f', label: 'Inactivo' }],
    },
  };

  async getFiltros() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorTramos(
      { '': '' },
      'conecta_mantenedor_tramos/get_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.tramoslist = data.data.TIPO.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getInfoTramo() {
    let self = this;
    this.loadingService.showLoading(undefined, 'getInfoTramo');
    return fetchMantenedorTramos(
      { id: this.Tramo_Seleccionada },
      'conecta_mantenedor_tramos/get_tramos'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data;
        }
      })
      .catch((error: any) => null)
      .finally(() => this.loadingService.hideLoading('getInfoTramo'));
  }
  ordesList2: any;
  data: any = {};

  async mounted() {
    this.getFiltros();
    if (this.isEdit) {
      this.ordesList2 = await this.getInfoTramo();
      this.data = this.ordesList2;
      this.formFields.id.value = this.data.id;
      this.formFields.nombre_tramo.value = this.data.nombre_tramo;
      this.formFields.tipo_tramo.value = this.data.tipo_tramo;
      this.formFields.activo.value = this.data.activo;
    }
  }

  handleCerrar() {
    this.$emit('cerrar');
  }
}
